'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import { classNames } from '@repo/ui/src/utils/classNames';
import { useEffect, useState } from 'react';

const CarouselItem = ({ category, link, image, imageContent, darkMode, isAnySelected, role, 'aria-label': ariaLabel }) => {
  const { path } = useCurrentUrl();
  const linkObj = buildLinkObj(link);
  const imgUrl = buildImageSrc(imageContent?.image ? imageContent : image, 60, 1, 1);

  const [selected, setSelected] = useState(false);

  useEffect(() => {
    setSelected(!!path && !!link && path === link.link);
  }, [path, link]);

  return (
    <>
      <a
        rel={getRel(linkObj)}
        href={`${linkObj.href}`}
        role={role}
        aria-label={ariaLabel || `Navigate to ${category} category`}
        className={classNames(
          'tw-rounded-md tw-mx-2 tw-px-2 tw-py-6 tw-flex-1 tw-flex tw-flex-col tw-justify-center',
          'tw-w-[calc(100%-16px)]',
          isAnySelected ? 'tw-mt-2.5 tw-h-[calc(100%-20px)]' : 'tw-mt-0 tw-h-full',
          selected ? 'tw-border-[3px] tw-border-brand-500' : 'tw-border tw-border-neutral-200',
          darkMode ? 'tw-bg-neutral-700' : 'tw-bg-warm-100',
          'lg:tw-max-w-48 lg:tw-mx-auto',
          'hover:tw-text-neutral-800 dark:hover:tw-text-neutral-100',
        )}
      >
        {imgUrl && (
          <LazyLoadImage
            imgComponent={
              /* eslint-disable-next-line @next/next/no-img-element */
              <img src={imgUrl} alt="" />
            }
            className='tw-mx-auto tw-pb-4 tw-max-w-[40px] md:tw-max-w-16'
          />
        )}
        <span
          className={classNames(
            'tw-text-center tra-text-web-heading-7',
            darkMode ? 'tw-text-neutral-100' : 'tw-text-gray-900',
          )}
        >
          {category}
        </span>
      </a>
      {selected && (
        <div className="tw-w-0 tw-h-0 tw-border-l-[10px] tw-border-r-[10px] tw-border-t-[10px] tw-border-l-transparent tw-border-r-transparent tw-border-t-brand-500 tw-mx-auto" />
      )}
    </>
  );
};

export default CarouselItem;
